import { SPOTLIGHT_TARGETS } from "../spotlightTargets";
import { SPOTLIGHT_EVENTS, SPOTLIGHT_SIGNAL_SCOPES } from "../spotlightEventNames";

const ZIP_PATTERN = /^\d{5}(-\d{4})?$/;

const hasText = (value) => typeof value === "string" && value.trim().length > 0;

const requiresProfile = (when, hint) => ({ scope: SPOTLIGHT_SIGNAL_SCOPES.PROFILE, when, hint });

const graduateProfileChapter = {
	id: "graduate-profile",
	title: "Graduate Profile",
	route: "Profile",
	isEligible: ({ userData }) => userData?.accountType === "Graduate",
	next: () => "hub-introduction",
	steps: [
		{
			id: "organization",
			target: SPOTLIGHT_TARGETS.PROFILE_ORGANIZATION,
			interactive: true,
			title: "University or organization",
			body: "Welcome, Graduate! Let's finish your graduate profile. Start typing your school and pick it from the list so friends can find you.",
			requires: requiresProfile(
				({ organizationName, organizationCode }) => !hasText(organizationName) || hasText(organizationCode),
				"Pick your school from the list (or clear the field) to continue."
			),
		},
		{
			id: "degree",
			target: SPOTLIGHT_TARGETS.PROFILE_DEGREE,
			interactive: true,
			title: "Degree or certificate",
			body: "Add the degree or certificate you're graduating with. This one is optional.",
		},
		{
			id: "institution-code",
			target: SPOTLIGHT_TARGETS.PROFILE_INSTITUTION_CODE,
			title: "Institution code",
			body: "This fills in automatically once you pick your school, so there's nothing to type. It's how MyTassel connects you with classmates from the same institution.",
		},
		{
			id: "graduation-date",
			target: SPOTLIGHT_TARGETS.PROFILE_GRADUATION_DATE,
			interactive: true,
			title: "Graduation date",
			body: "Let everyone know when the big day is. Pick the month, day, and year of your graduation.",
		},
		{
			id: "shipping-address",
			target: SPOTLIGHT_TARGETS.PROFILE_SHIPPING_ADDRESS,
			interactive: true,
			title: "Shipping address",
			body: "This is where gifts and cards will be sent. It will be important for your Registry later, so make sure it's accurate.",
			requires: requiresProfile(({ shippingAddress }) => hasText(shippingAddress), "Enter your street address to continue."),
		},
		{
			id: "shipping-city",
			target: SPOTLIGHT_TARGETS.PROFILE_SHIPPING_CITY,
			interactive: true,
			title: "City",
			body: "Which city should your Registry gifts be shipped to?",
			requires: requiresProfile(({ shippingCity }) => hasText(shippingCity), "Enter your city to continue."),
		},
		{
			id: "shipping-state",
			target: SPOTLIGHT_TARGETS.PROFILE_SHIPPING_STATE,
			interactive: true,
			title: "State",
			body: "Choose your state from the list.",
			requires: requiresProfile(({ shippingState }) => hasText(shippingState), "Choose your state to continue."),
		},
		{
			id: "shipping-zip",
			target: SPOTLIGHT_TARGETS.PROFILE_SHIPPING_ZIP,
			interactive: true,
			title: "ZIP code",
			body: "Last piece of your shipping address. We'll use it to make sure your Registry deliveries find you.",
			requires: requiresProfile(({ shippingZip }) => ZIP_PATTERN.test((shippingZip || "").trim()), "Enter a valid ZIP code to continue."),
		},
		{
			id: "save-graduate-profile",
			target: SPOTLIGHT_TARGETS.PROFILE_SAVE,
			interactive: true,
			title: "Save your graduate profile",
			body: "Press Save to lock in your details. Your shipping address will be used when you set up your Registry.",
			instruction: "Click Save to continue",
			waitFor: { event: SPOTLIGHT_EVENTS.PROFILE_SAVED },
		},
	],
};

export default graduateProfileChapter;
